import angular from 'angular';
import DjangoClient from './django-client.service/djangoClient';

export default angular
    .module('tn.django', [])
    // providers
    .constant('apiBaseURl', 'TN_APIBASEURL')
    // actually CMS base URL, EE is no longer used, but we haven't updated this var name.
    // it needs to be variables to support different environments.
    .constant('cmsBaseURl', 'TN_CMSBASEURL')
    .service('djangoClient', DjangoClient).name;
